import { IAtleta } from "./atleta";
import { ICategoriaEvento, IDistanciaEvento, IEventoResponse } from "./eventos";
import { ICamiseta } from "./kitsCamiseta";
import { ITipoPagamento } from "./payment";

export const StatusInscricaoMap = {
  Pendente: 1,
  Pago: 2,
  Cancelado: 3,
  RecOrganizador: 4,
  Cortesia: 5,
  Gratuito: 7,
} as const;

export type TypeStatusInscricao = keyof typeof StatusInscricaoMap;

export interface IInscricaoCreateRequest {
  formaPaymento: string;
  eventoId: number;
  cupomPromocao?: string;
  obs?: string;
  taxa: number;
  frete: number;
  subTotal: number;
  totalInscricao: number;
  totalDesconto: number;
  totalTaxa: number;
  inscritos: IInscritos[];
}
export interface IInscricoesInscritoRequest {
  inscritos: IInscritos[];
}

export interface IInscritos {
  eventoId: number;
  atleta_id: number;
  categoria_id: number;
  tamanhoCamiseta: string | null;
  acceptTermo: boolean;
  valorDesconto: number;
  valorInscricao: number;
}

export interface IInscriçaoResponse {
  id: number;
  cpfResponsavel: string;
  createAt: string;
  cupomPromocao: null;
  dataInscricao: string;
  eventoId: number;
  frete: string;
  nomeResponsavel: string;
  numeroInscricao: string;
  obs: string;
  statusInsc_id: number;
  subTotal: string;
  taxa: string;
  totalDesconto: string;
  totalInscricao: string;
  totalTaxa: string;
  updatedAt: string;
}

export type ICartInscritoProps = {
  userId: string;
  eventoSelected: IEventoResponse | null;
  inscrito: IInscritoCart[];
};

export interface IInscritoCart {
  atleta: IAtleta;
  camiseta: ICamiseta | null;
  category: ICategoriaEvento;
  distancia: IDistanciaEvento;
  termoResp: boolean;
  valorTagEvento: number;
}

// ATLETAS INSCRITOS
//------------------------------------------------------------------------------
export interface IAtletasInscritos {
  inscricaoId: number;
  tamanhoCamiseta: string;
  valorDesconto: string;
  valorInscricao: string;
  inscricao: Inscricao;
  atleta: Atleta;
  categoria: CategoriaAtletaInscrito;
}

interface Inscricao {
  dataInscricao: string;
  nomeResponsavel: string;
  statusInscricao: { tipo: string };
  pagamentos: Pagamentos | null;
}

interface Pagamentos {
  tipoPagamento: { tipoPagamento: string };
}

interface Atleta {
  id?: number;
  nome: string;
  cpf: string;
  dataNascimento: string;
  sexo: Sexo;
  equipe: string;
  enderecos: Endereco[];
}

interface Sexo {
  tipo: string;
}

interface Endereco {
  cidade: string;
  uf: string;
}

export interface CategoriaAtletaInscrito {
  id?: number;
  descricao: string;
  distancia: Distancia;
  sexo: Sexo;
  idadeInicial?: number;
  idadefinal?: number;
}
interface Distancia {
  id?: number;
  descricao: string;
  distancia: number;
  unidade: string;
}

//----------------------------------------------------------------------------
// RETORNO LISTA DE INSCRIÇÕES
//----------------------------------------------------------------------------
export interface IListInscricoesActive {
  _count: Count;
  id: number;
  numeroInscricao: string;
  cpfResponsavel: string;
  nomeResponsavel: string;
  dataInscricao: string;
  cupomPromocao: string;
  obs: string;
  taxa: string;
  frete: string;
  subTotal: string;
  totalInscricao: string;
  totalDesconto: string;
  totalTaxa: string;
  canalInscricao?: "SITE" | "APP" | "PAINEL";
  plataformaApp?: "IOS" | "ANDROID" | null;
  evento: IInscricaoEvento;
  statusInscricao: StatusInscricao;
  inscritos: IListInscrito[];
  pagamentos: DetailsPagamentos;
}
interface Count {
  inscritos: number;
}
export interface IInscricaoEvento {
  id: number;
  titulo: string;
  slug: string;
  urlImageDestaque: string;
  dataEvento: string;
  horaLargada: string;
  camisetas: Camiseta[];
  distanciaEvento: DistanciaEvento[];
}

interface Camiseta {
  tamanho: string;
}

export interface DistanciaEvento {
  id: number;
  descricao: string;
  distancia: number;
  unidade: string;
  categoriaEvento: CategoriaEvento[];
}

interface CategoriaEvento {
  id: number;
  descricao: string;
  idadeInicial: number;
  idadefinal: number;
  sexo: Sexo;
}
interface StatusInscricao {
  tipo: TypeStatusInscricao;
}
export interface IListInscrito {
  atleta: Atleta;
  categoria: CategoriaAtletaInscrito;
  tamanhoCamiseta: string;
  valorDesconto: string;
  valorInscricao: string;
}

export interface DetailsPagamentos {
  dataVencimento: string;
  dataBaixa: string;
  cobrancaPix: CobrancaPix;
  cobrancaBoleto: CobrancaBoleto;
  tipoPagamento: ITipoPagamento;
}
interface CobrancaPix {
  id: string;
  dataCriaca: string;
  txid: string;
  locId: number;
  status: string;
  valorOriginal: string;
  chave: string;
  pagamento_id: number;
  createAt: string;
  updatedAt: string;
}
interface CobrancaBoleto {
  id: number;
  expire_at: string;
  pdf_change: string;
  charge_id: number;
  status: string;
}
//---------------------------------------------------------------------------
